module.exports = __webpack_public_path__ + "static/media/three.38d0f099.ogg";